import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { ClaimStatus } from 'src/app/core/enums/claim-status.enum';
import { UserRol } from 'src/app/core/enums/user-rol.enum';
import { Failure } from 'src/app/core/utils/failure';
import { ClaimsPaginationParamsModel } from 'src/app/features/claims/data/models/claim-pagination-params.model';
import { ClaimData } from 'src/app/features/claims/domain/entities/claim-data.entity';
import { ClaimPagination } from 'src/app/features/claims/domain/entities/claim-pagination.entity';
import { ClaimServiceService } from 'src/app/features/claims/services/claim-service.service';
import { UserData } from 'src/app/features/user/domain/entities/user-data.entity';
import { UserService } from 'src/app/features/user/services/user.service';
import { Toast } from 'primeng/toast';
import { Router } from '@angular/router';
import { LocalStorageServiceBase } from 'src/app/core/services/localStorage-serviceBase';
import AESEncryptDecryptService from 'src/app/core/utils/crypto';
import { GetAllConciliatorsUseCase } from 'src/app/features/user/domain/usecases/get-all-conciliators.usecase';
import { Pagination } from 'src/app/core/interfaces/pagination.interface';
import { UpdateClaimStatusModel } from 'src/app/features/claims/data/models/update-claim-status.model';
import { UpdateClaimConciliatorModel } from 'src/app/features/claims/data/models/update-claim-consciliator.model';
import { ClaimFilterModel } from 'src/app/features/claims/data/models/claim-filter.model';
import { ClaimEntity } from 'src/app/features/claims/domain/entities/claim.entity';
import { GetPaginatedAllClaimsUseCase } from 'src/app/features/claims/domain/usecases/get-pagination-all-claims.usecase';
import { ClaimUseCase } from 'src/app/features/claims/domain/usecases/get-claim.usecase';
import { UpdateClaimStatusUseCase } from 'src/app/features/claims/domain/usecases/update-claim-status.usecase';
import { UpdateClaimConciliatorUseCase } from 'src/app/features/claims/domain/usecases/update-claim-conciliator.usecase';
import { GetPaginatedAllClaimsByConciliatorUseCase } from 'src/app/features/claims/domain/usecases/get-pagination-all-cliams-by-conciliator.usecase';
import { UpdateClaimStatusEntity } from 'src/app/features/claims/domain/entities/update-claim-satus.entity';
import { UpdateClaimConciliatorEntity } from 'src/app/features/claims/domain/entities/update-claim-conciliator.entity';
import { FilterServiceService } from 'src/app/features/claims/services/filter-service.service';

@Component({
  selector: 'app-claims-comision-table',
  templateUrl: './claims-comision-table.component.html',
  styleUrls: ['./claims-comision-table.component.css'],
  providers: [MessageService, Toast, ConfirmationService],
})
export class ClaimsComisionTableComponent implements OnInit {
  claims!: ClaimPagination | undefined;
  @Input() userData?: UserData;

  public status: string[] = [
    ClaimStatus.PENDING,
    ClaimStatus.REFUSED,
    ClaimStatus.ADMITTED,
    ClaimStatus.AUDIENCE_SET,
    ClaimStatus.IN_INTERNAL_PROCESS,
    ClaimStatus.FINALIZED,
  ];

  public conciliators: UserData[] = [];

  public pagination: Pagination = {
    totalQuantity: 0,
    numberOfPages: 0,
    itemsPerPage: 5,
    actualPage: 1,
  };
  public skeleton: boolean = true;
  public skeletons: any = [{}, {}, {}, {}, {}];

  userClaims?: ClaimData[];
  paginatedData: ClaimPagination | undefined = undefined;
  selectedClaimId?: string;
  isLoading: boolean = true;
  claim?: ClaimEntity;
  tableOrImg: boolean = false;
  newClaims?: number;
  private AES = new AESEncryptDecryptService();
  homeView: boolean = false;
  rol?: string;
  isComisionMemberRol: boolean = false;
  isAdministratorRol: boolean = false;
  isConciliatorRol: boolean = false;
  isComisionRol: boolean = false;
  newStatusClaimUpdate?: UpdateClaimStatusModel;
  originalStatus: string | null = null;
  newConciliatorClaimUpdate?: UpdateClaimConciliatorModel;
  userId?: string;
  audienciaDialogVisible: boolean = false;
  isLoadingSpinner: boolean = false;
  filters?: ClaimFilterModel;

  haveResults: boolean = true;

  audienceId?: string;
  dateAudience?: Date;
  timeAudience?: string;
  minuteDialogVisible: boolean = false;

  public items: MenuItem[] = [];

  public audienceSetItems: MenuItem[] = [
    {
      label: 'Ver reclamo',
      icon: 'pi pi-eye ',
      command: () => this.viewClaim(),
    },
    {
      label: 'Fijar nueva audiencia',
      icon: 'pi pi-calendar-plus',
      command: () => this.setNewAudience(),
    },
  ];
  public pendingAudienceItems: MenuItem[] = [
    {
      label: 'Ver reclamo',
      icon: 'pi pi-eye ',
      command: () => this.viewClaim(),
    },
    {
      label: 'Fijar audiencia',
      icon: 'pi pi-calendar-plus',
      command: () => this.setNewAudience(),
    },
  ];

  public singleItem: MenuItem[] = [
    {
      label: 'Ver reclamo',
      icon: 'pi pi-eye',
      command: () => this.viewClaim(),
    },
  ];

  constructor(
    private getPaginatedAllClaimsUseCase: GetPaginatedAllClaimsUseCase,
    private userService: UserService,
    private claimService: ClaimServiceService,
    private router: Router,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private claimUseCase: ClaimUseCase,
    private localStorageService: LocalStorageServiceBase,
    private getAllConciliatorsUseCase: GetAllConciliatorsUseCase,
    private updateClaimStatusUseCase: UpdateClaimStatusUseCase,
    private updateClaimConciliatorUseCase: UpdateClaimConciliatorUseCase,
    private getAllPAginatedClaimsofConciliatorUseCase: GetPaginatedAllClaimsByConciliatorUseCase,
    private filterService: FilterServiceService
  ) {}

  ngOnInit(): void {
    this.userId = this.AES.decrypt(
      this.localStorageService.loadStorageData('user_id')
    );
    this.rol = this.AES.decrypt(
      this.localStorageService.loadStorageData('user_rol')
    );
    if (this.router.url.includes('main/home')) {
      this.homeView = true;
    }
    this.setRol();
    const savedFilters = this.filterService.getFilters('indi-filters');
    if (
      savedFilters &&
      !this.homeView &&
      localStorage.getItem('indi-response') === 'succes'
    ) {
      this.filters = savedFilters;
      this.initClaims();
    } else {
      this.filterService.clear('indi-filters');
      this.initClaims();
    }
    if (this.rol == UserRol.ADMINISTRATOR) {
      this.getAllConciliators();
    }
  }

  handleLoadingChange(loading: boolean) {
    this.isLoadingSpinner = loading;
  }

  setRol() {
    switch (this.rol) {
      case UserRol.COMISSION:
        return (this.isComisionRol = true);
      case UserRol.COMISSION_MEMBER:
        return (this.isComisionMemberRol = true);
      case UserRol.ADMINISTRATOR:
        return (this.isAdministratorRol = true);
      case UserRol.CONCILIATOR:
        return (this.isConciliatorRol = true);
      default:
        return;
    }
  }

  suscribeToUserGetMe(): void {
    this.userService.userData$.subscribe((user: UserData) => {
      this.initUserData();
    });
  }

  initUserData(): void {
    this.userData = this.userService.userData;
  }

  initClaims(): void {
    if (!this.userId) return;
    this.getDataPaginated();
  }

  async getDataPaginated(): Promise<void> {
    this.skeleton = true;
    let params = new ClaimsPaginationParamsModel(
      this.pagination.actualPage,
      this.pagination.itemsPerPage
    );
    params.userId = this.userId;
    params.filters = this.filters;
    let result;
    if (this.isConciliatorRol) {
      result = await this.getAllPAginatedClaimsofConciliatorUseCase.execute(
        params
      );
    } else if (this.isAdministratorRol || this.isComisionMemberRol) {
      result = await this.getPaginatedAllClaimsUseCase.execute(params);
    }
    if (result) {
      localStorage.setItem('indi-response', 'succes');
      setTimeout(() => {
        this.skeleton = false;
      }, 200);
    }
    if (result instanceof Failure) {
      localStorage.setItem('indi-response', 'error');
      this.haveResults = false;
      this.skeleton = false;
      return;
    }
    this.processClaimsResult(result!);
  }

  private processClaimsResult(result: ClaimPagination): void {
    this.haveResults = true;
    if (!this.filters) {
      this.userClaims = this.sortByDate(result.response);
    } else {
      this.userClaims = result.response;
    }
    this.paginatedData = result;
    this.claimService.claimsData = result.response;
    this.pagination.totalQuantity = result.totalQuantity;
    this.countNewClaims(result.response);
  }

  updateStatusCheck(event: any) {
    this.confirmationService.confirm({
      header: 'Actualizar estado',
      message: `¿Está seguro de que desea actualizar el estado del reclamo?`,
      accept: () => {
        this.newStatusClaimUpdate = new UpdateClaimStatusModel(
          this.selectedClaimId!,
          event.value
        );
        this.updateClaimStatus(this.newStatusClaimUpdate);
      },
      reject: () => {
        this.getDataPaginated();
      },
    });
  }

  async getClaim(): Promise<void> {
    let result = await this.claimUseCase.execute(this.selectedClaimId!);
    if (result instanceof Failure) {
      return;
    }
    this.claim = result;
  }

  async getAllConciliators(): Promise<void> {
    const result = await this.getAllConciliatorsUseCase.execute();
    if (result instanceof Failure) {
      return;
    }
    const noAssignedOption: UserData = {
      id: '',
      name: 'No asignado',
      lastName: '',
      rol: '',
      cuil: '',
      gender: '',
      birthDate: new Date(),
      province: '',
      phone: '',
      email: '',
      civilStatus: '',
      city: '',
      street: '',
      number: '',
      floorApartment: '',
      postalCode: 0,
      company: '',
      companyCuil: '',
      dni: '',
      neighborhood: '',
      toJson: function (): Map<string, any> {
        throw new Error('Function not implemented.');
      },
    };
    this.conciliators = [noAssignedOption, ...result];
  }

  async updateClaimStatus(claim: UpdateClaimStatusEntity): Promise<void> {
    let result = await this.updateClaimStatusUseCase.execute(claim);
    if (result instanceof Failure) {
      this.messageService.add({
        severity: 'error',
        summary: 'Ocurrió un problema.',
        detail: 'Estado no actualizado.',
        life: 900,
      });
      this.getDataPaginated();
      return;
    }
    this.messageService.add({
      severity: 'success',
      summary: 'Estado actualizado',
      detail: 'El estado se actualizó exitosamente.',
    });
    this.getDataPaginated();
  }

  async updateClaimConciliator(
    claim: UpdateClaimConciliatorEntity
  ): Promise<void> {
    let result = await this.updateClaimConciliatorUseCase.execute(claim);
    if (result instanceof Failure) {
      this.messageService.add({
        severity: 'error',
        summary: 'Ocurrió un problema.',
        detail: 'Conciliador no actualizado.',
        life: 900,
      });
      this.getDataPaginated();
      return;
    }
    this.messageService.add({
      severity: 'success',
      summary: 'Conciliador actualizado',
      detail: 'El conciliador se actualizó exitosamente.',
    });
    setTimeout(() => {
      this.getDataPaginated();
    }, 1500);
  }

  dropdownClick(claim: ClaimData) {
    this.updateStatusOptionsByStatusClaim(claim.status);
    this.originalStatus = claim.status;
    this.selectedClaimId = claim.id;
  }

  updateConciliatorCheck(event: any) {
    const conciliatorName = event.value.id
      ? `${event.value.name} ${event.value.last_name}`
      : 'eliminar el conciliador actual';

    this.confirmationService.confirm({
      header: 'Actualizar conciliador',
      message: `¿Está seguro de que desea ${
        event.value.id ? 'actualizar el conciliador actual por' : ''
      } ${conciliatorName}?`,
      accept: () => {
        this.newConciliatorClaimUpdate = new UpdateClaimConciliatorModel(
          this.selectedClaimId!,
          event.value.id ? event.value.id : 'No asignado'
        );
        this.updateClaimConciliator(this.newConciliatorClaimUpdate);
      },
      reject: () => {
        this.getDataPaginated();
      },
    });
  }

  isConciliatorChangeAllowed(status: string): boolean {
    const allowedStatuses = ['Pendiente', 'Admitido'];
    return allowedStatuses.includes(status);
  }

  countNewClaims(claims: ClaimData[]): void {
    let count: number = 0;
    claims.forEach((claim) => {
      if (claim.status == ClaimStatus.PENDING) {
        count += 1;
      }
    });
    this.newClaims = count;
  }

  changePage(event: any) {
    this.pagination.actualPage = event.page + 1;
    this.pagination.itemsPerPage = event.rows;
    this.skeleton = true;
    this.getDataPaginated();
  }

  getStatusClass(status: string, claimDate?: Date): string {
    switch (status) {
      case ClaimStatus.DRAFT:
        return 'status-draft';
      case ClaimStatus.PENDING:
        return 'status-pending';
      case ClaimStatus.REFUSED:
        return 'status-refused';
      case ClaimStatus.FINALIZED:
        if (this.isConciliatorRol && !this.claimDiffDate(claimDate!)) {
          return 'status-finalized-diff-date';
        }
        return 'status-finalized';
      case ClaimStatus.IN_INTERNAL_PROCESS:
        return 'status-in-internal-process';
      case ClaimStatus.AUDIENCE_SET:
      case 'Audiencia Fijada':
        return 'status-audience-set';
      case ClaimStatus.ADMITTED:
        return 'status-admited';
      default:
        return '';
    }
  }

  sortByDate(claims: ClaimData[]): ClaimData[] {
    return claims.sort((a, b) => {
      const dateA = new Date(a.startDate).getTime();
      const dateB = new Date(b.startDate).getTime();
      return dateB - dateA;
    });
  }

  selectMenuItemsByRol(status: string, claimDate?: Date, claimTime?: string) {
    this.dateAudience = claimDate;
    this.timeAudience = claimTime;
    if (
      this.rol === UserRol.ADMINISTRATOR ||
      this.rol === UserRol.CONCILIATOR
    ) {
      this.selectAmountComisionItems(status);
    } else {
      this.items = this.singleItem;
    }
  }

  selectAmountComisionItems(status: string) {
    switch (status) {
      case ClaimStatus.AUDIENCE_SET:
        this.items = [...this.audienceSetItems];
        break;
      case ClaimStatus.IN_INTERNAL_PROCESS:
      case ClaimStatus.ADMITTED:
        this.items = [...this.pendingAudienceItems];
        break;
      default:
        this.items = [...this.singleItem];
        break;
    }
  }

  getClassForRole(rol: string): string {
    switch (rol) {
      case 'Trabajador':
        return 'status-pending';
      case 'Empleador':
        return 'status-audience-set';
      case 'Representante gremial':
        return 'status-admited';
      default:
        return '';
    }
  }

  getStatusClassForPrincipalView(status: string): string {
    switch (status) {
      case ClaimStatus.DRAFT:
        return 'status-draft-principal';
      case ClaimStatus.PENDING:
        return 'status-pending-principal';
      case ClaimStatus.REFUSED:
        return 'status-refused-principal';
      case ClaimStatus.FINALIZED:
        return 'status-finalized-principal';
      case ClaimStatus.IN_INTERNAL_PROCESS:
        return 'status-in-internal-process-principal';
      case ClaimStatus.AUDIENCE_SET:
      case 'Audiencia Fijada':
        return 'status-audience-set-principal';
      case ClaimStatus.ADMITTED:
        return 'status-admited-principal';
      case ClaimStatus.ADMITTED:
        return 'status-admited';
      default:
        return '';
    }
  }

  updateStatusOptionsByStatusClaim(status: string) {
    switch (status) {
      case ClaimStatus.PENDING:
        this.status = [ClaimStatus.REFUSED, ClaimStatus.ADMITTED];
        break;
      case ClaimStatus.IN_INTERNAL_PROCESS:
        this.status = [ClaimStatus.FINALIZED];
        break;
      case ClaimStatus.AUDIENCE_SET:
        this.status = [ClaimStatus.IN_INTERNAL_PROCESS];
        break;
      case ClaimStatus.FINALIZED:
        this.status = [ClaimStatus.IN_INTERNAL_PROCESS];
        break;
      default:
        this.status = [];
        break;
    }
  }

  claimDiffDate(claimDate: Date): boolean {
    const now = new Date();
    const diffInMs = now.getTime() - new Date(claimDate).getTime();
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    return diffInDays <= 15;
  }

  cancel(close: any) {
    this.audienciaDialogVisible = false;
    this.minuteDialogVisible = false;
  }

  createAudienceOk(close: any) {
    this.getDataPaginated();
  }

  handleShowMessage(event: {
    severity: string;
    summary: string;
    detail: string;
  }) {
    this.messageService.add({
      severity: event.severity,
      summary: event.summary,
      detail: event.detail,
    });
  }

  refreshGetAll() {
    location.reload();
  }

  selectClaim(id: string, idAudience: string) {
    this.selectedClaimId = id;
    this.audienceId = idAudience;
    this.getClaim();
  }

  verificateAudienceDate(): boolean {
    if (!this.dateAudience) return false;
    const now = new Date();
    const audienceDateTime = new Date(this.dateAudience);
    if (this.timeAudience) {
      const [hours, minutes] = this.timeAudience.split(':').map(Number);
      audienceDateTime.setHours(hours, minutes, 0, 0);
    }
    return now > audienceDateTime;
  }

  viewClaim() {
    if (this.selectedClaimId) {
      this.router.navigate(['/main/claims', this.selectedClaimId]);
    }
  }

  setNewAudience() {
    this.audienciaDialogVisible = true;
  }

  createMinute() {
    this.minuteDialogVisible = true;
  }

  onFiltersApplied(filters: ClaimFilterModel) {
    this.filters = filters;
    this.pagination.actualPage = 1;
    this.filterService.setFilters(filters, 'indi-filters');
    this.getDataPaginated();
  }

  onFilterCancel(): void {
    this.pagination.actualPage = 1;
    this.filters = undefined;
    this.filterService.clear('indi-filters');
    this.getDataPaginated();
  }
}
